export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
export const isFirefox = navigator.userAgent.indexOf('Firefox') !== -1;
export const visibilityChangeTime = {
  mobile: 2000,
  web: 8000,
};
